const commonCode = {
  STATUS_SERVER_DISCONNECTED: -1,
  STATUS_OK: 0,
  STATUS_FAIL: 1,
  STATUS_UNAUTH: 2,
  STATUS_TIMEOUT: 3,
  STATUS_MULTI: 4,
  STATUS_MULTI_GUEST: 5,
  STATUS_RESET: 6,
  STATUS_WIZARD: 7,
  STATUS_CONFLICT: 8,
  STATUS_TRAFFIC_LIMIT: 9,
  MAX_REBOOT_TIME: 180,
  MIN_REBOOT_TIME: 50,
  PRE_WAIT_STAIC_IP_CONFLICT: 40,
  PRE_WAIT_PPTP_STATIC: 50, // Same with L2TP
  PRE_WAIT_PPTP_DHCP: 80, // Same with L2TP
  PRE_WAIT_PPPOE: 80,
};
export default commonCode;
